import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const HomePointPinIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.homePointPinIcon}`}
        data-testid={testId}
        fill='none'
        height='42'
        viewBox='0 0 24 32'
        width='32'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M 12 0 C 5.373 0 0 5.373 0 12 C 0 21 12 32 12 32 C 12 32 24 21 24 12 C 24 5.373 18.627 0 12 0 Z'
            fill='currentColor'
        />

        <circle className={styles.dot} cx='12' cy='12' fill='currentColor' r='4' />
    </svg>
);

export default HomePointPinIcon;
